import 'react-app-polyfill/stable'

import React from 'react'
import { createRoot } from 'react-dom/client'

import 'chart.js/auto'
import 'animate.css/animate.min.css'

import App from './App'
import { ThemeProvider } from './contexts/ThemeContext'

import { LicenseInfo } from '@mui/x-license'

// This is the license key for the @mui/x-license package (grid and datepicker components).
LicenseInfo.setLicenseKey(
    '58dc516e8edffc0679bc140f4892866eTz0xMzIyNjcsRT0xODE5MDY1NTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1zaW5nbGUsS1Y9Mg==',
)

// Note: Remove the following line if you want to disable the API mocks.
// import "./mocks";

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
    <ThemeProvider>
        <App />
    </ThemeProvider>,
)
